export const ROUTE_PATH = '/ipn-reports';
